import { MapDataItem } from '@bpd-library/types';
import { ExtendedAreaModels, ExtendedProjectPhase, findProjectPhase } from '@bpd-library/utilities';
import { getSoldProjectsData } from '@features/properties/store';
import { createConstructionNumberMapData } from '@utilities/map/service';
import { partition } from '@utilities/partition';

export const filterSoldProjectPhasesData = (data: ExtendedAreaModels): ExtendedAreaModels => {
    const [soldProjects = [], notSoldProjects = []] = partition(
        data.projectPhases,
        ({ status }) => status === 'Sold',
    );
    const [soldPropertyTypes = [], notSoldPropertyTypes = []] = partition(
        data.propertyTypes,
        ({ projectPhase }) => projectPhase?.status === 'Sold',
    );
    const [soldConstructionNumbers = [], notSoldConstructionNumbers = []] = partition(
        data.constructionNumbers,
        ({ projectPhase }) => projectPhase?.status === 'Sold',
    );
    const [soldApartmentBuildings = [], notSoldApartmentBuildings = []] = partition(
        data.apartmentBuildings,
        ({ projectPhase }) => projectPhase?.status === 'Sold',
    );

    data.projectPhases = notSoldProjects;
    data.propertyTypes = notSoldPropertyTypes;
    data.constructionNumbers = notSoldConstructionNumbers;
    data.apartmentBuildings = notSoldApartmentBuildings;

    return {
        ...data,
        projectPhases: soldProjects,
        propertyTypes: soldPropertyTypes,
        constructionNumbers: soldConstructionNumbers,
        apartmentBuildings: soldApartmentBuildings,
    };
};

export const getSoldProjectPhase = (id: string) => {
    const { projectPhases: soldProjects = [] } = getSoldProjectsData() ?? {};
    return findProjectPhase(soldProjects, { id });
};

export const getSoldProjectPhaseMapData = (): MapDataItem[] => {
    const mapData: MapDataItem[] = [];

    const { projectPhases: soldProjects = [] } = getSoldProjectsData() ?? {};

    soldProjects
        .filter(({ mapDataItems }) => !!mapDataItems?.length)
        .map<MapDataItem[]>(({ mapDataItems }) => mapDataItems!)
        .forEach((items) => mapData.push(...items));

    return mapData;
};

export const toggleSoldProjectPhaseConstructionNumberPolygons = (
    projectPhase: ExtendedProjectPhase,
    visible: boolean,
) => {
    if (projectPhase.status !== 'Sold') return;
    projectPhase.constructionNumbers?.forEach((constructionNumber) => {
        constructionNumber.mapDataItems = createConstructionNumberMapData(constructionNumber, {
            showSold: visible,
        });
    });
};

export const shouldToggleSoldProjectPolygon = (projectPhase?: ExtendedProjectPhase): boolean => {
    if (!projectPhase || projectPhase.status !== 'Sold') return false;

    // toggle project polygon only if there is no available polygons for every nested construction number
    return !!projectPhase.constructionNumbers?.every(({ mapDataItems }) => !mapDataItems?.length);
};
